// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchFaultFeatureTag {
constructor({
        id = null,
        name = '',
        parentId = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchFaultFeatureTag();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.em.archive.emArchFaultFeatureTag.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.archive.emArchFaultFeatureTag.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emArchFaultFeatureTag.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchFaultFeatureTag.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    parentIdFilter : "",
    nameFilter : "",
    levelFilter : "",
    seqFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.em.archive.emArchFaultFeatureTag.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultFeatureTag'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchFaultFeatureTag.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.archive.emArchFaultFeatureTag.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.em.archive.emArchFaultFeatureTag.filter.seq',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.archive.emArchFaultFeatureTag.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.em.archive.emArchFaultFeatureTag.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultFeatureTag'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emArchFaultFeatureTag.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchFaultFeatureTag.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchFaultFeatureTag, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
